import React, { lazy } from 'react';
import PermissionService from '@Services/PermissionService';
const Accounts = lazy(() => import('./components/Accounts'));

export const accountsConfig = [
	{
		auth: true,
		component: <Accounts/>,
		name: 'accounts',
		path: '/accounts',
		pm: (pm) => PermissionService(pm).getAccountsList(),
	},
]